// libraries
import styled, { css } from 'styled-components';

export const modalHeaderStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 600;
  height: 66px;
  border-bottom: 1px solid #e6e6e6;
  box-sizing: border-box;
  padding: 0 23px 0 28px;
`;

export const modalBodyStyle = css`
  padding: 25px 28px;

  .grid-field-wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    .MuiFormControl-root {
      &:last-child {
        grid-column: 1 / span 2;
      }
    }
  }
`;

export const sectionHeaderStyle = css`
  color: #b38b3a;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;
  position: relative;
  margin-left: 8px;
  padding-left: 16px;
  display: flex;
  align-items: end;
  justify-content: space-between;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0%;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: transparent;
    border: 2px solid #b38b3a;
    transform: translate(-50%, -50%);
  }
`;

export const searchBarStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;

  > div {
    display: flex;
    align-items: center;

    &.left {
      flex-wrap: wrap;
      gap: 12px;
    }

    &.right {
      gap: 12px;

      > button {
        white-space: nowrap;
      }
    }
  }
`;

export const searchBoxStyle = css`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const searchLabelStyle = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const headerRowStyle = css`
  &:hover {
    color: var(--color-primary-blue) !important;
    background-color: var(--color-off-white) !important;

    * {
      color: var(--color-primary-blue) !important;
      background-color: var(--color-off-white) !important;
    }
  }
`;

export const labelStyles = css`
  &.left {
    display: flex;
    align-items: center;
    gap: 8px;

    > span {
      min-width: 90px;
    }
  }
`;

interface RowProps {
  gap?: string;
  fullWidth?: boolean;
}

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.gap || '16px'};
  flex: ${(p) => (p.fullWidth ? '1 1 0%' : null)};
`;

interface ColumnProps {
  gap?: string;
  fullWidth?: boolean;
}

export const Column = styled.div<ColumnProps>`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.gap || '16px'};
  flex: ${(p) => (p.fullWidth ? '1 1 0%' : null)};
`;
